<template>
    <b-modal
        :title="'Stone certificate form'"
        :visible="value"
        :id="'modal-certificate'"
        @ok="manageCertificate"
        size="md"
        @close="$emit('close')"
        @cancel="$emit('close')"
        no-close-on-backdrop
    >
        <b-form>
            <b-form-group
                id="fieldset-serial_number"
                :label="$t('Certificate ID')"
                label-for="input-1"
                :invalid-feedback="errors['certificate_id']"
                :state="getFieldState('certificate_id')"
            >
                <b-form-input
                    required
                    :state="getFieldState('certificate_id')"
                    v-model="certificate_id"
                    :placeholder="$t('Certificate ID')"
                ></b-form-input>
            </b-form-group>
            <b-form-group
                id="fieldset-file"
                :label="$t('File')"
                label-for="input-1"
                :invalid-feedback="errors['file']"
                :state="getFieldState('file')"
            >
                <b-form-file
                    v-model="file"
                    :state="Boolean(file)"
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                ></b-form-file>
            </b-form-group>
            <file-items
                v-if="files_preview.length"
                :files="files_preview"
            ></file-items>
        </b-form>
    </b-modal>
</template>

<script>
import axios from "axios";
import FileItems from "../Product/FileItems";

export default {
  name: "CertificateFormDialog",
  props: {
    value: Boolean,
    serialNumber: Object,
    certificate: String,
    id: Number,
    files: Array
  },
  components: { FileItems },
  data() {
    return {
      files_preview: this.files,
      file: null,
      model_id: this.id,
      certificate_id: this.certificate,
      errors: {},
      saving: false
    };
  },
  methods: {
    getFieldState(field) {
      return this.errors[field] === undefined ? null : false;
    },
    manageCertificate() {
      if (this.model_id > 0) {
        this.editCertificate();
      } else {
        this.createCertificate();
      }
    },
    createCertificate() {
      let fData = new FormData();
      fData.append("certificate_id", this.certificate_id);
      fData.append("file", this.file);
      axios
        .post(
          "/api/instances/" + this.serialNumber.id + "/stone-certificates",
          fData
        )
        .then(response => {
          this.certificate_id = null;
          this.$emit("certificate-added", response.data.data);
        })
        .catch(error => {
          this.$emit("close");
        });
    },
    editCertificate() {
      let fData = new FormData();
      fData.append("certificate_id", this.certificate_id);
      if (this.file !== null) {
        fData.append("file", this.file);
      }
      axios
        .post(
          "/api/instances/" +
            this.serialNumber.id +
            "/stone-certificates/" +
            this.id,
          fData
        )
        .then(response => {
          this.certificate_id = null;
          this.$emit("certificate-updated", response.data.data);
        })
        .catch(error => {
          this.$emit("close");
        });
    }
  }
};
</script>

<style scoped>
</style>
